﻿/* globals AlertaDTO */
var jquery = require("jquery");
var HabEvents = require("../../Global/habitaclia-events");

(function () {
    "use strict";
    var __alertaDTO;
   
    var Alerta = function (alertaDTO) {
        __alertaDTO = alertaDTO;
        __registerEvents.call(this);
    };

    var __registerEvents = function () {

        var self = this;

        jquery('#idFiltros-alerta, #idsoloON-alerta').change(function () {
            if (jquery(this).is(':checked')) {
               jquery(this).val('1');
            }
            else {
               jquery(this).val('0');
            }
        });

        jquery(".jsBotonAlerta").click(function (e) {
            e.preventDefault();
            jquery.publish(HabEvents.EventsEnum.AlertAdded);
            var oEmail = jquery("#id_email_FormAlerta");
            var oDataGtm = jquery("#idDivAlerta").data();
            var sUrlAlertas = __alertaDTO.urlAlertas;
            var legal = jquery('#idCheckLegal');
            var isLegalChecked = false;
            if (legal.length > 0) {
                isLegalChecked = legal.prop('checked');
            } else if (__alertaDTO.UserIsLogged) {
                isLegalChecked = true;
            }
            
            if (oEmail.val() === '' || !__validaEmail.call(self, oEmail[0])) {
                alert('Email incorrecto');
                return false;
            }
            else {
                var checkboxs = jquery(".check-cajon-alerta");
                checkboxs.each(function (i, ck) {
                    var jck = jquery(ck);
                    jck.addClass("ocultar");
                });

                __alertaDTO.urlAlertas = __getUrlAlertasConEmail.call(self, oEmail.val());
                __alertaDTO.urlAlertas = __getUrlAlertasConLegal.call(self, isLegalChecked);
                __alertaDTO.urlAlertas = __getUrlAlertasConCheckFiltros.call(self);
                __alertaDTO.urlAlertas = __getUrlAlertasConCheckObraNueva.call(self);
                jquery.ajax({
                    type: "GET",
                    async: false,
                    url: __alertaDTO.urlAlertas,
                    dataType: "json"
                }).done(function (result) {
                    jquery.publish(HabEvents.EventsEnum.AddAlertaListado, [result.alertas, 'Informacion', 'lista', 'alertasinferior', oDataGtm]);
                    jquery.publish(HabEvents.EventsEnum.AlertAddedSuccess);
                    __alertaDTO.urlAlertas = sUrlAlertas;
                    var msg;
                    var hasMailToo = (jquery(".alert-box:not('.toast')").length > 1 ? true : false);
                    if (!hasMailToo) {
                        jquery(".alert-box .info-box .icon .sprite").addClass("done").removeClass("bell");
                        jquery(".alert-box").addClass("mail-too");
                        msg = jquery(".alert-box.mail-too .copys");
                        msg.html(parseHTML(result.description));
                    }
                    if (result.status === 0) {
                        jquery("#id_email_FormAlerta").remove();
                        jquery("#boton-alerta-not-logged").remove();
                        jquery("#legal-bottom-not-logged").remove();
                        if (hasMailToo) {
                            if (jQuery(".alert-box").eq(0).hasClass("ocultar")) {
                                jquery(".jsBotonAlerta").remove();
                                jquery(".legal-bottom").remove();
                                jquery(".form-box").remove();
                                jquery(".info-box").removeClass('error-alert').addClass("done-alert");
                                msg = jquery(".alert-box.mail-too .copys");
                                msg.html(parseHTML(result.description));
                            } else {
                                jQuery(".alert-box").eq(0).removeClass("mostrar").addClass("ocultar");
                                jquery(".alert-box.mail-too").removeClass("ocultar").addClass("mostrar");
                            }
                            
                        }

                        setTimeout(function () { document.location.href = "#anchor-busquedas-top"; }, 200);
                        var formBox = jquery(".alert-box.mail-too .form-box");
                        if (formBox.children().length === 0) {
                            formBox.remove();
                             jquery(".info-box").removeClass('error-alert').addClass("done-alert");
                        }
                        
                    }
                    else {
                        jquery(".info-box").addClass("error-alert");
                    }
                }).fail(function (request, type) {
                    console.log(type);
                });
            }
        });

        var parseHTML = function (html) {
            var parsedHTML = "";
            var el = jquery("<div></div>");
            el.html(html);
            parsedHTML = "<h4>" + jquery('h5', el).html() + "</h4>";
            parsedHTML += "<span>" + jquery('div', el).html().substring(parsedHTML.length) + "</span>";
            return parsedHTML;
        };
    };

    /* Esta función comprueba que una dirección email es correcta */
    var __validaEmail = function (form) {
        var mail = (form.value);
        var reg1 = /(@.*@)|(\.\.)|(@\.)|(\.@)|(^\.)/;									// no válidos
        var reg2 = /^.+\@(\[?)[a-zA-Z0-9\-\.]+\.([a-zA-Z]{2,3}|[0-9]{1,3})(\]?)$/;		// válidos

        if (!reg1.test(mail) && reg2.test(mail)) { // si la sintaxis es correcta
            return true;
        }
        else {
            return false;
        }
    };

    var __getUrlAlertasConEmail = function (email) {
        if (email) {
            var urlAlertaConEmail = __alertaDTO.urlAlertas + "&" + "email_FormAlerta=" + email;
            return urlAlertaConEmail;
        }
        else {
            return __alertaDTO.urlAlertas;
        }

    };

    var __getUrlAlertasConLegal = function (legal) {
        if (legal) {
            return __alertaDTO.urlAlertas + "&" + "avisolegal=si";
        } else {
            return __alertaDTO.urlAlertas;
        }
    };

    var __getUrlAlertasConCheckFiltros = function () {
        var aplicarFiltros = 0;
        if (jquery("#idFiltros-alerta").is(":checked")) {
            aplicarFiltros = 1;
        }
       
        var urlAlertaConEmail = __alertaDTO.urlAlertas + "&" + "filtros-alerta=" + aplicarFiltros;
        return urlAlertaConEmail;     
    };

    var __getUrlAlertasConCheckObraNueva = function () {
        var checkObraNueva = 0;
        if (jquery("#idsoloON-alerta").is(":checked")) {
            checkObraNueva = 1;
        }

        var urlAlertaConEmail = __alertaDTO.urlAlertas + "&" + "soloON-alerta=" + checkObraNueva;
        return urlAlertaConEmail;
    };


    Alerta.prototype = {
        constructor: Alerta
    };

    if (typeof module !== 'undefined' && module.exports) {
        module.exports.Alerta = new Alerta(AlertaDTO);
    }
    else {
        window.Alerta = new Alerta(AlertaDTO);
    }
}());